import { Component, OnInit, ElementRef, HostListener, ViewChild, OnDestroy } from '@angular/core';
import { PetitionerService } from "src/app/services/petitioner.service";
import { ApiServicesService } from '../../services/api-services.service';
import { fromEvent, Subject, Subscription } from 'rxjs';
import { debounceTime, map, filter, takeUntil, take } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';
import { CreateNewBeneficiaryComponent } from '../../create-new-beneficiary/create-new-beneficiary.component';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';


@Component({
    selector: 'app-bene-list-grid',
    templateUrl: './bene-list-grid.component.html',
    styleUrls: ['./bene-list-grid.component.scss'],
    providers: [DialogService]
})
export class BeneListGridComponent implements OnInit, OnDestroy {
    allEmployeesData = {
        notIntiatedList: [],
        intiatedList: [],
        completedList: [],
        selfList: [],
        authRepresentativeList: [],
        verifyByAgentList: [],
        inProgressList: []
    };

    initiatedData: any[] = [];
    verifyYourselfData: any[] = [];
    videoVerificationData: any[] = [];
    verificationByEvaluatorData: any[] = [];
    verificationByAuthRepresenativeData: any[] = [];
    inProgressList = [];

    totalRecordCount: number;
    pageSizeOptions: number[] = [25, 50, 100];
    pageIndex = 0;
    pageSize = 50;
    searchText = '';
    beneficiaryStatus = 'ACTIVE';
    listOfClientCompanies: any[];
    selectedCompanyId = 0;
    observableSubscription$ = new Subject();
    companyIdSelected = 0;
    taskDetailsSubscription$ = new Subject();
    dataSource: any = [];
    isFilter: boolean = false;
    filter: any = { name: '', type: '', companyId: '' };
    _data: any;
    userType: string;
    ref: DynamicDialogRef;
    noRecordFound: boolean = false;

    viewEmployeeBy = [
        { label: 'Active Employees', value: 'activeEmployees' },
        { label: 'Inactive Employees', value: 'inActiveEmployees' },
    ];

    employeeViewBy = 'activeEmployees';
    displayedData: any[] = [];
    searchSubscription: Subscription;
    @ViewChild('searchBeneficiaryListTable', { static: true }) searchBeneficiaryListTable: ElementRef;
    constructor(
        private petitionerService: PetitionerService,
        private apiService: ApiServicesService,
        private router: Router,
        private route: ActivatedRoute,
        public dialogService: DialogService,
        private elementRef: ElementRef
    ) { }

    ngOnInit(): void {
        this.userType = sessionStorage.getItem('userTypeRole');
        const payload = {
            pageNumber: this.pageIndex + 1,
            pageSize: this.pageSize,
            // searchCriteria: '',
            searchText: this.searchText,
            // sortBy: 'beneficiaryName',
            // sortOrder: 'asc',
        };
        // this.getbeneficiaryListForPetitioner(payload);
        this.getEmployeesData(payload);
        this.searchSetUp();
    }

    getClientsList() {
        this.petitionerService.getPetitionerClientList(parseInt(sessionStorage.getItem('companyId')))
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((response: any[]) => {
                let options = [];
                response.forEach(ele => {
                    options.push({ 'petitionerId': ele['id'], 'petitionerName': ele['companyName'] })
                });
                this.listOfClientCompanies = options;
                this.selectedCompanyId = this.companyIdSelected != 0 ? this.companyIdSelected : this.listOfClientCompanies[0].petitionerId;
                // this.handleCompanyChange();
            });
    }

    getbeneficiaryListForPetitioner(payload) {
        let companyid = this.selectedCompanyId;
        if (!companyid) {
            companyid = parseInt(sessionStorage.getItem('companyId'));
        }
        this.apiService.getBeneficiariesListForPetitioner(companyid, payload)
            .pipe(takeUntil(this.taskDetailsSubscription$))
            .subscribe(result => {
                if (result) {
                    const beneList = result.beneficiaryList;
                    beneList.forEach(item => {
                        item.name = `${item.beneficiaryEmployeeFName} ${item.beneficiaryEmployeeMName || ''} ${item.beneficiaryEmployeeLName}`;

                    });

                    this.totalRecordCount = this.beneficiaryStatus === 'ACTIVE' ?
                        result.totalActiveRecords :
                        (this.beneficiaryStatus === 'PEND' ? result.totalPendingRecords : result.totalPastRecords);
                    // this.totalActiveRecords = result.totalActiveRecords ? result.totalActiveRecords : 0;
                    // this.totalPastRecords = result.totalPastRecords ? result.totalPastRecords : 0;
                    // this.totalPendingRecords = result.totalPendingRecords ? result.totalPendingRecords : 0;

                    this.dataSource = beneList;
                    this.noRecordFound = false;

                } else {
                    // this.totalRecordCount = 0;
                    this.dataSource = [];
                    this.noRecordFound = true;
                }
            });
    }

    resetSearch() {
        const payload = {
            pageNumber: this.pageIndex + 1,
            pageSize: this.pageSize,
            // searchCriteria: '',
            searchText: this.searchText,
            // sortBy: 'beneficiaryName',
            // sortOrder: 'asc',
        };
        // this.getbeneficiaryListForPetitioner(payload);
        this.getEmployeesData(payload);
    }

    filterOpen() {
        this.isFilter = !this.isFilter;
    }

    @HostListener('document:click', ['$event'])
    onClickOutside(event: Event) {
        if (!this.elementRef.nativeElement.contains(event.target)) {
            this.isFilter = false;
        }
    }

    @HostListener('document:keydown.escape', ['$event'])
    onEscPress(event: KeyboardEvent) {
        this.isFilter = false;
    }

    closeFilter() {
        this.isFilter = false;
    }

    stopPropagation(event: Event) {
        event.stopPropagation();
    }

    editBene(row) {
        const queryParamsObj = {
            companyId: row.companyId || 0,
            beneficiaryId: row.beneficaryId || 0,
            beneficiaryFName: row.beneficiaryEmployeeFName ? row.beneficiaryEmployeeFName : 'Not Available',
            beneficiaryLName: row.beneficiaryEmployeeLName ? row.beneficiaryEmployeeLName : '',
            status: row.status ? row.status : 'Not Available',
        }
        this.router.navigate(['../i9-employee-details'], { queryParams: queryParamsObj, relativeTo: this.route });
    }


    filterAction() {
        this.filter.companyId = parseInt(sessionStorage.getItem('companyId'));
        this.apiService.searcFilterNewUI(this.filter).subscribe(res => {
            this._data = res;
            const beneList = this._data.data.beneficiaryList;


            beneList.forEach(item => {
                item.name = `${item.beneficiaryEmployeeFName} ${item.beneficiaryEmployeeMName || ''} ${item.beneficiaryEmployeeLName}`;

            });

            this.totalRecordCount = this.beneficiaryStatus === 'ACTIVE' ?
                this._data.data.totalActiveRecords :
                (this.beneficiaryStatus === 'PEND' ? this._data.data.totalPendingRecords : this._data.data.totalPastRecords);

            this.dataSource = beneList;
        });
        this.filter = { name: '', type: '', companyId: '' };
        this.isFilter = false;

    }

    listView() {
        this.router.navigate(['../list'], { relativeTo: this.route });
    }

    openFormModalCreate() {
        this.ref = this.dialogService.open(CreateNewBeneficiaryComponent, {
            header: this.userType == 'Beneficiary' ? 'Create Beneficiary' : 'Create Employee',
            width: '70%',
            contentStyle: { 'max-height': '800px', overflow: 'auto' }
        });
    }
    paginationEvent(event) {
        this.pageSize = event.pageSize;
        this.pageIndex = event.pageIndex;

        const payload = {
            pageNumber: this.pageIndex + 1,
            pageSize: this.pageSize,
            // searchCriteria: '',
            searchText: this.searchText,
            // sortBy: 'beneficiaryName',
            // sortOrder: 'asc',
        };

        // this.getbeneficiaryListForPetitioner(payload);
        this.getEmployeesData(payload);
    }
    backToDashboard() {
        this.router.navigate(['petitioner-landing/dashboard/petitioner-dashboard']);
    }

    getEmployeesData(payload) {
        let companyid = this.selectedCompanyId;
        if (!companyid) {
            companyid = parseInt(sessionStorage.getItem('companyId'));
        }
        this.apiService.getEmployeesListForI9Admin(companyid, payload)
            .pipe(takeUntil(this.taskDetailsSubscription$))
            .subscribe(result => {
                if (result) {
                    this.allEmployeesData = result;
                    this.inProgressList = [...this.allEmployeesData.selfList, ...this.allEmployeesData.intiatedList, ...this.allEmployeesData.authRepresentativeList, ...this.allEmployeesData.verifyByAgentList, ...this.allEmployeesData.inProgressList];

                    this.displayedData = [...this.allEmployeesData.notIntiatedList, ...this.inProgressList, ...this.allEmployeesData.completedList];
                    this.mapInProgressData()

                } else {
                    this.displayedData = [];
                    this.dataSource = [];
                }
            });

    }
    onTabChange(event: any): void {
        switch (event.index) {
            case 0:
                this.displayedData = [...this.allEmployeesData.notIntiatedList, ...this.inProgressList, ...this.allEmployeesData.completedList];
                break;
            case 1:
                this.displayedData = this.allEmployeesData.notIntiatedList;
                break;
            case 2:
                this.displayedData = this.inProgressList;
                break;
            case 3:
                this.displayedData = this.allEmployeesData.completedList;
                break;
        }
    }


    onInProgressTabChange(event: any): void {
        switch (event.index) {
            case 0:
                this.displayedData = this.inProgressList;
                break;
            case 1:
                this.displayedData = this.initiatedData;
                break;
            case 2:
                this.displayedData = this.verifyYourselfData;
                break;
            case 3:
                this.displayedData = this.videoVerificationData;
                break;
            case 4:
                this.displayedData = this.verificationByEvaluatorData;
                break;
            case 5:
                this.displayedData = this.verificationByAuthRepresenativeData;
                break;
        }
    }


    viewEmployeeByChange() {
        const payload = {
            pageNumber: this.pageIndex + 1,
            pageSize: this.pageSize,
            // searchCriteria: '',
            searchText: '',
            // sortBy: 'beneficiaryName',
            // sortOrder: 'asc',
        };
        if (this.employeeViewBy == 'activeEmployees') {
            this.getEmployeesData(payload);
        } else {
            this.getInactiveEmployeeList(payload);
        }
    }

    mapInProgressData() {
        this.initiatedData = this.allEmployeesData.intiatedList;
        this.verifyYourselfData = this.allEmployeesData.selfList;
        this.videoVerificationData = this.allEmployeesData.inProgressList;
        this.verificationByEvaluatorData = this.allEmployeesData.verifyByAgentList;
        this.verificationByAuthRepresenativeData = this.allEmployeesData.authRepresentativeList;
    }

    getInactiveEmployeeList(payload) {
        let companyid = this.selectedCompanyId;
        if (!companyid) {
            companyid = parseInt(sessionStorage.getItem('companyId'));
        }
        this.apiService.getInactiveEmployeesListForI9Admin(companyid, payload)
            .pipe(takeUntil(this.taskDetailsSubscription$))
            .subscribe(result => {
                if (result) {
                    this.displayedData = result.dtoList;
                } else {
                    this.displayedData = [];
                    this.dataSource = [];
                }
            });
    }

    searchSetUp() {
        this.searchSubscription = fromEvent(this.searchBeneficiaryListTable.nativeElement, 'keyup').pipe(
            map((event: any) => event.target.value)
            , filter(res => !res || (res && (res.length > 2 || res.length === 0)))
            , debounceTime(1000)).subscribe((text: string) => {
                this.searchText = text.trim();
                this.viewEmployeeByChange();
            });
    }
    ngOnDestroy() {
        this.searchSubscription.unsubscribe();
    }
}
